export const NIVEIS_DE_EXPANCAO = {
  PRIMEIRO: 1,
  SEGUNDO: 2,
  TERCEIRO: 3,
  QUARTO: 4,
}
